import { Component } from '@angular/core';

@Component({
  selector: 'magic-ai',
  templateUrl: './magic-ai.component.html',
  styleUrls: ['./magic-ai.component.scss'],
})
export class MagicAiComponent {
  constructor() {
    window.scrollTo(0, 0);
  }
}
